export interface PrevBoxDimensions {
  height: number;
  weight: number;
  length: number;
  width: number;
  unitOfMeasurement: string;
}

interface ShipmentProduct {
  description: string;
  quantity: number;
  unitValue: number;
  HSNName: string;
  HSNCode: string;
  _product: any;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

interface ShipmentBox {
  length: number;
  width: number;
  height: number;
  weight: number;
  status: string;
  products: ShipmentProduct[];
  childAWBNumber: string;
  carrierNumber: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

interface ShipmentDetails {
  box: ShipmentBox[];
  isDropOff: boolean;
  timeSlot: string;
  isDocument: boolean;
  pickupDate: string;
  insurance: boolean;
  packaging: boolean;
  unitOfMeasurement: string;
  currency: string;
}

type StatusDetail = {
  status: string;
  [key: string]: any;
};

type Shipment = {
  statusDetails: StatusDetail[];
  [key: string]: any;
};

export function isInTransit(shipment?: Shipment): boolean {
  if (!shipment || !shipment.statusDetails) return false;
  return shipment.statusDetails.some(detail => detail.status === 'in_transit');
}

export function getBoxDimensionsByAWB(shipment: ShipmentDetails, childAWBNumber: string): PrevBoxDimensions | null {
  if (!Array.isArray(shipment.box)) {
    console.error("Invalid or missing 'box' array in shipment object.");
    return null;
  }

  const foundBox = shipment.box.find(box => box.childAWBNumber === childAWBNumber);

  if (!foundBox) return null;

  return {
    height: foundBox.height,
    weight: foundBox.weight,
    length: foundBox.length,
    width: foundBox.width,
    unitOfMeasurement: shipment.unitOfMeasurement,
  };
}
